import { TradesDistrictReport } from '@api/order-reporting/types-deliveries/DeliveriesReports';
import { TradesDistrictReportGridData } from '@pages/reporting-pages/deliveries-trades-district/types/TradesDistrictReportGridData';
import { valueExist } from '@utils/typescriptGuards';
import { MainTransportTypes } from '@api/order-reporting/types-deliveries/CountryDeliveriesSummaryReport';



export const convertToGridData = (apiData: TradesDistrictReport[] | undefined | null): TradesDistrictReportGridData[] | null => {
	if (!apiData) return null;

	let gridData: TradesDistrictReportGridData[] = [];
	if (apiData.length === 0)
		return gridData;
	
	for (const apiDataItem of apiData) {
		const totalValue = apiDataItem.transportTypesData[MainTransportTypes.total];
		const sdValue = apiDataItem.transportTypesData[MainTransportTypes.sd];
		const intValue = apiDataItem.transportTypesData[MainTransportTypes.int];
		const ddValue = apiDataItem.transportTypesData[MainTransportTypes.dd];
		const tdValue = apiDataItem.transportTypesData[MainTransportTypes.td];

		gridData.push({
			onOffTrade: apiDataItem.onOffTrade && apiDataItem.onOffTrade === true ? 'ON Trade' : 'OFF Trade',
			country: apiDataItem.country,
			tradeCode: apiDataItem.tradeCode,

			total_volume: totalValue && valueExist(totalValue.volume) ? totalValue.volume : 0,
			total_volumePct: totalValue && valueExist(totalValue.volumePct) ? totalValue.volumePct : 0,
			total_weight: totalValue && valueExist(totalValue.weight) ? totalValue.weight : 0,
			total_ordersCount: totalValue && valueExist(totalValue.ordersCount) ? totalValue.ordersCount : 0,
			total_returnsWeight: totalValue && valueExist(totalValue.returnsWeight) ? totalValue.returnsWeight : 0,

			sd_volume: sdValue && valueExist(sdValue.volume) ? sdValue.volume : 0,
			sd_volumePct: sdValue && valueExist(sdValue.volumePct) ? sdValue.volumePct : 0,
			sd_weight: sdValue && valueExist(sdValue.weight) ? sdValue.weight : 0,
			sd_ordersCount: sdValue && valueExist(sdValue.ordersCount) ? sdValue.ordersCount : 0,
			sd_returnsWeight: sdValue && valueExist(sdValue.returnsWeight) ? sdValue.returnsWeight : 0,

			int_volume: intValue && valueExist(intValue.volume) ? intValue.volume : 0,
			int_volumePct: intValue && valueExist(intValue.volumePct) ? intValue.volumePct : 0,
			int_weight: intValue && valueExist(intValue.weight) ? intValue.weight : 0,
			int_ordersCount: intValue && valueExist(intValue.ordersCount) ? intValue.ordersCount : 0,
			int_returnsWeight: intValue && valueExist(intValue.returnsWeight) ? intValue.returnsWeight : 0,

			dd_volume: ddValue && valueExist(ddValue.volume) ? ddValue.volume : 0,
			dd_volumePct: ddValue && valueExist(ddValue.volumePct) ? ddValue.volumePct : 0,
			dd_weight: ddValue && valueExist(ddValue.weight) ? ddValue.weight : 0,
			dd_ordersCount: ddValue && valueExist(ddValue.ordersCount) ? ddValue.ordersCount : 0,
			dd_returnsWeight: ddValue && valueExist(ddValue.returnsWeight) ? ddValue.returnsWeight : 0,

			td_volume: tdValue && valueExist(tdValue.volume) ? tdValue.volume : 0,
			td_volumePct: tdValue && valueExist(tdValue.volumePct) ? tdValue.volumePct : 0,
			td_weight: tdValue && valueExist(tdValue.weight) ? tdValue.weight : 0,
			td_ordersCount: tdValue && valueExist(tdValue.ordersCount) ? tdValue.ordersCount : 0,
			td_returnsWeight: tdValue && valueExist(tdValue.returnsWeight) ? tdValue.returnsWeight : 0,
		});
	}

	return gridData;
}